import { render } from "./FooterEng.vue?vue&type=template&id=6d58338d"
import script from "./FooterEng.vue?vue&type=script&lang=js"
export * from "./FooterEng.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__